export enum ControlPanelInterconnectLength {
  Interconnect1200 = 'Interconnect1200',
  Interconnect2000 = 'Interconnect2000',
  Interconnect6500 = 'Interconnect6500',
}
